import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "./Reveal";

export function Preloader({ onDone }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (typeof navigator !== "undefined" && navigator.webdriver) {
      setShow(false);
      onDone?.();
      return;
    }
    const t = setTimeout(() => {
      setShow(false);
      onDone?.();
    }, 2200);
    return () => clearTimeout(t);
  }, [onDone]);

  const letters = "NODINO".split("");

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[9999] flex items-center justify-center"
          style={{ background: "var(--bg)" }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1, ease: EASE }}
          data-testid="preloader"
        >
          <div className="flex flex-col items-center">
            <motion.div
              initial={{ scale: 0.4, opacity: 0, rotate: -20 }}
              animate={{ scale: 1, opacity: 1, rotate: 0 }}
              transition={{ duration: 1, ease: EASE }}
              className="mb-6"
            >
              <svg width="46" height="46" viewBox="0 0 24 24" fill="none">
                <path d="M4 20 L4 4 L20 20 L20 4" stroke="#D4AF37" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="12" cy="12" r="2.4" stroke="#AA8C2C" strokeWidth="1" />
              </svg>
            </motion.div>
            <div className="flex overflow-hidden">
              {letters.map((l, i) => (
                <motion.span
                  key={i}
                  className="font-display text-4xl md:text-6xl tracking-[0.3em]"
                  initial={{ y: "110%", opacity: 0 }}
                  animate={{ y: "0%", opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.4 + i * 0.07, ease: EASE }}
                >
                  {l}
                </motion.span>
              ))}
            </div>
            <motion.div
              className="gold-rule mt-6"
              initial={{ width: 0 }}
              animate={{ width: 180 }}
              transition={{ duration: 1.1, delay: 0.9, ease: EASE }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
